/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
/**
 * This object store all the default settings of the application.
 */
export const DefaultSettings = {
    /**
     * Adress of the backend API.
     */
    HTTP_ENDPOINT: 'http://localhost:3000/api',
    /**
     * Polling settings to retrieve the chat answer or HITL questions.
     */
    POLLING_SETTINGS: {
        // 3 seconds between two calls.
        interval: 3000,
        // retry 40 times.
        maxRetries: 40,
        // increase the delay from 0s to 3s for the 5 first calls.
        rampUp: 5,
    },
    /**
     * Mobile width breakpoint.
     */
    MOBILE_SCREEN_WIDTH_BREAKPOINT: 600,
};
//# sourceMappingURL=default-settings.js.map